export const common = {
  scrollToTop: "Volver arriba",
  pagination: {
    totalItems: 'Total de elementos',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página',
    showing: 'Mostrando',
    to: 'a',
    of: 'de',
    items: 'elementos'
  },
  actions: {
    edit: 'Editar',
    delete: 'Eliminar',
    expand: 'Expandir',
    collapse: 'Colapsar',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    print: 'Imprimir',
    export: 'Exportar',
    add: 'Añadir',
    title: 'Acciones'
  },
  status: {
    active: 'Activo',
    inactive: 'Inactivo'
  },
  loading: 'Cargando...',
  noData: 'No hay datos disponibles',
  filters: {
    sort: {
      label: 'Ordenar por',
      placeholder: 'Seleccionar campo',
      directions: {
        asc: 'Ascendente',
        desc: 'Descendente'
      }
    }
  }
}; 